var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('slide-controls');
import { breakpoints, theme } from '@shapeable/theme';
import { Icons } from '../icons';
import { Icon } from '../elements/icon';
var ChevronLeft = Icons.ChevronLeft,
    ChevronRight = Icons.ChevronRight;
export var SlideControlsDefaultProps = {
  index: 0,
  activeColor: '#000000',
  style: {}
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", ";\n  "])), theme.FILL('light'))
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    margin: 0 ", ";\n    &:hover {\n      ", ";\n    }\n  "], ["\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    margin: 0 ", ";\n    &:hover {\n      ", ";\n    }\n  "])), theme.UNIT(1), theme.FILL('link-hover'))
});
var PrevStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n\n  "], ["\n    ", ";\n\n  "])), IconStyles)
});
var NextStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var DotButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    padding: ", ";\n    cursor: pointer;\n    display: flex;\n\n    \n  "], ["\n    ", ";\n    padding: ", ";\n    cursor: pointer;\n    display: flex;\n\n    \n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(2))
});
var DotStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 0;\n    width: 10px;\n    border: 1px solid ", ";\n    height: 10px;\n    background: ", ";\n    \n    ", "\n  "], ["\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 0;\n    width: 10px;\n    border: 1px solid ", ";\n    height: 10px;\n    background: ", ";\n    \n    ", "\n  "])), theme.COLOR('light'), theme.COLOR('light'), function (_a) {
    var isActive = _a.isActive,
        activeColor = _a.activeColor;
    return isActive && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR(activeColor));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  DotButton: styled.button.attrs(cls.attr('dot-button'))(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""]))),
  Dot: styled.span.attrs(cls.attr('dot'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DotStyles),
  Prev: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), PrevStyles),
  Next: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), NextStyles)
};
My.DotButton = styled.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", ";\n\n  &:hover {\n    ", " {\n      background: ", ";\n    }\n  }\n"], ["\n  ", ";\n\n  &:hover {\n    ", " {\n      background: ", ";\n    }\n  }\n"])), DotButtonStyles, My.Dot, theme.COLOR('link-hover'));
export var SlideControls = function SlideControls(props) {
  var className = props.className,
      onPrev = props.onPrev,
      onNext = props.onNext,
      count = props.count,
      index = props.index,
      onSelect = props.onSelect,
      style = props.style,
      activeColor = props.activeColor;

  var onPrevClick = function onPrevClick() {
    if (onPrev) {
      onPrev();
    }
  };

  var onNextClick = function onNextClick() {
    if (onNext) {
      onNext();
    }
  };

  return React.createElement(My.Container, {
    style: style,
    className: cls.name(className)
  }, React.createElement(My.Prev, {
    onClick: onPrevClick
  }, React.createElement(ChevronLeft, null)), __spreadArray([], __read(Array(count).keys()), false).map(function (i) {
    return React.createElement(My.DotButton, {
      type: "button",
      key: i,
      onClick: function onClick() {
        if (onSelect) {
          onSelect(i);
        }
      }
    }, React.createElement(My.Dot, {
      activeColor: activeColor,
      isActive: i === index
    }));
  }), React.createElement(My.Next, {
    onClick: onNextClick
  }, React.createElement(ChevronRight, null)));
};
SlideControls.defaultProps = SlideControlsDefaultProps;
SlideControls.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;